/**
 * Dato il valore di una select e la lista dei suoi possibili valori,
 * ritorna il valore filtrato con solo gli elementi possibili.
 *
 * Per una multiple select ritorna un array (vuoto se non ci sono valori possibili)
 * Per una single select ritorna il valore (null se non è possibile)
 */
export function getFilteredSelectedValues(
  value: any,
  mode: 'multiple' | 'tags' | undefined,
  optionListValues: (string | number | undefined)[],
) {
  if (mode === 'tags' || !value) return { changed: false };

  // Se il valore è un array, devo filtrare i valori che non sono presenti nella lista
  if (Array.isArray(value) && mode != null) {
    const resultValues = value.filter(v => {
      return optionListValues.includes(v);
    });

    // Se non ci sono differenze tra i value e le options, allora non devo fare nulla
    if (resultValues.length === value.length) {
      return { changed: false };
    }

    // Se la option non c'è devo resettare il campo
    return { changed: true, value: resultValues };
  }

  // Se la modalità non è multipla, devo filtrare il valore singolo
  if (optionListValues.includes(value)) {
    return { changed: false };
  }

  // Se la option non c'è devo resettare il campo
  return { changed: true, value: null };
}
